export default (
  <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 30.7 56" width="100%" height="100%">
    <g>
      <g>
        <path
          fill="#FF6600"
          d="M29.7,16.4L16.3,0.2c-0.3-0.3-0.8-0.1-0.8,0.3l1.1,15.7L6.9,7.8c-0.3-0.3-0.8,0-0.7,0.4l3.9,15.5l-9.4-5.5
          C0.4,18,0,18.4,0.1,18.7l16.4,37c0.2,0.4,0.7,0.3,0.8-0.1l3.6-19l9.1-15.5C31,19.7,30.8,17.7,29.7,16.4L29.7,16.4z M29.7,16.4"
        />
        <path fill="#E74030" d="M16.6,16.2L6.8,7.8C6.5,7.5,6,7.8,6.1,8.2L10,23.7l7.4,4.4L16.6,16.2z M16.6,16.2" />
        <path
          fill="#FAB418"
          d="M16.7,47.6c-0.1,0.4-0.7,0.4-0.8-0.1L10,23.7l-9.4-5.5C0.3,18-0.1,18.4,0,18.7l16.4,37
          c0.2,0.4,0.7,0.3,0.8-0.1l3.6-19l-0.1,0.1L16.7,47.6z M16.7,47.6"
        />
        <path
          fill="#DE0732"
          d="M16.7,47.6l4-10.8l-1.8,3c-0.2,0.4-0.8,0.2-0.8-0.2l-0.8-11.5L10,23.7l5.9,23.8C16,47.9,16.6,48,16.7,47.6"
        />
        <path
          fill="#FF6600"
          d="M29.6,16.4L16.2,0.2C16-0.2,15.4,0,15.5,0.5l1.1,15.7l6.8,5.8c1.4,1.2,1.8,3,1.2,4.7l-3.7,9.9l0,0.1L30,21.2
          C30.9,19.7,30.7,17.7,29.6,16.4"
        />
      </g>
      <path
        fill="#DE0733"
        d="M19.4,29.3c1.5,0.9,2.3,2.7,2,4.4l-0.5,2.9l3.7-9.9c0.6-1.7,0.1-3.5-1.2-4.7l-6.8-5.8l0.8,11.9L19.4,29.3z
        M19.4,29.3"
      />
      <path
        fill="#CC1D46"
        d="M19.4,29.3l-2-1.2l0.8,11.5c0,0.4,0.6,0.5,0.8,0.2l1.8-3l0.1-0.2l0.5-2.9C21.7,31.9,20.9,30.2,19.4,29.3"
      />
    </g>
  </svg>
);
